import { z } from 'zod';
import { PaymentStatus, PaymentConcept } from '@academia-apolo/shared-types';
export const registerPaymentSchema = z.object({
    student_id: z.string().uuid(),
    month: z.number().int().min(1).max(12),
    year: z.number().int().min(2020).max(2100),
    amount: z.number().int().positive('El importe debe ser positivo'), // En céntimos
    status: z.nativeEnum(PaymentStatus),
    // Defaults to the monthly fee; pass 'enrollment' to register a matrícula that
    // can coexist with the same month's monthly payment.
    concept: z.nativeEnum(PaymentConcept).default(PaymentConcept.MONTHLY),
    // Collection date, only valid together with status 'paid'. Omitted → today.
    // Date-only: the API normalizes it to a timestamp and rejects future dates.
    paid_at: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato: YYYY-MM-DD').optional(),
    notes: z.string().max(500).optional(),
});
/** Switch a pending monthly payment between the full fee and the reduced (65 €) one. */
export const setPaymentFeeSchema = z.object({
    reduced: z.boolean(),
});
// concept is immutable once created — only status/amount/notes can be edited.
export const updatePaymentSchema = registerPaymentSchema
    .partial()
    .omit({ student_id: true, concept: true })
    .refine((d) => Object.keys(d).length > 0, { message: 'Al menos un campo debe ser proporcionado' });
//# sourceMappingURL=payment.schema.js.map